"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _store_api = _interopRequireDefault(require("./store_api"));
class SourceApi extends _store_api.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      storeApiUrl,
      entityType
    } = _ref;
    super({
      userTokenFactory,
      storeApiUrl
    });
    if (entityType) {
      this.entityType = entityType;
    }
  }
  async getEntities(_ref2) {
    let {
      entityType
    } = _ref2;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.get(`${this.storeApiUrl}/api/sources/${type}`, headers)).then(response => Promise.resolve(response.data));
  }
  async getEntity(_ref3) {
    let {
      entityType,
      id
    } = _ref3;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.get(`${this.storeApiUrl}/api/sources/${type}/${id}`, headers)).then(response => Promise.resolve(response.data));
  }
  async addEntity(_ref4, payload) {
    let {
      entityType
    } = _ref4;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.post(`${this.storeApiUrl}/api/sources/${type}`, payload, headers)).then(response => Promise.resolve(response.data));
  }
  async patchEntityMeta(_ref5, payload) {
    let {
      entityType,
      id
    } = _ref5;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.patch(`${this.storeApiUrl}/api/sources/${type}/${id}/meta`, payload, headers)).then(response => Promise.resolve(response.data));
  }
  async deleteEntity(_ref6) {
    let {
      entityType,
      id
    } = _ref6;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.delete(`${this.storeApiUrl}/api/sources/${type}/${id}`, headers)).then(response => Promise.resolve(response.data));
  }
  async getSource(_ref7) {
    let {
      entityType,
      id,
      sourceId
    } = _ref7;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.get(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}`, headers)).then(response => Promise.resolve(response.data));
  }
  async deleteSource(_ref8) {
    let {
      entityType,
      id,
      sourceId
    } = _ref8;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.delete(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}`, headers)).then(response => Promise.resolve(response.data));
  }
  async patchSourceMeta(_ref9, payload) {
    let {
      entityType,
      id,
      sourceId
    } = _ref9;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.patch(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}/meta`, payload, headers)).then(response => Promise.resolve(response.data));
  }
  async forkSource(_ref10, payload) {
    let {
      entityType,
      id,
      sourceId
    } = _ref10;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.post(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}/fork`, payload, headers)).then(response => Promise.resolve(response.data));
  }
  async setPublished(_ref11, payload) {
    let {
      entityType,
      id,
      sourceId
    } = _ref11;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.post(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}/published`, payload, headers)).then(response => Promise.resolve(response.data));
  }
  async getRevision(_ref12) {
    let {
      entityType,
      id,
      sourceId,
      revisionId
    } = _ref12;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.get(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}/revision/${revisionId}`, headers)).then(response => Promise.resolve(response.data));
  }
  async addRevision(_ref13, payload) {
    let {
      entityType,
      id,
      sourceId
    } = _ref13;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.post(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}/revision`, payload, headers)).then(response => Promise.resolve(response.data));
  }
  async setSandbox(_ref14, payload) {
    let {
      entityType,
      id,
      sourceId,
      revisionId
    } = _ref14;
    const type = entityType || this.entityType;
    const headers = await this.getHeaders();
    return Promise.try(() => _axios.default.post(`${this.storeApiUrl}/api/sources/${type}/${id}/source/${sourceId}/revision/${revisionId}/sandbox`, payload, headers)).then(response => Promise.resolve(response.data));
  }
}
var _default = SourceApi;
exports.default = _default;